import React from "react";
import { FaArrowAltCircleLeft, FaArrowAltCircleRight } from "react-icons/fa";

function Pagination({ page, callback }) {
  return (
    <>
      <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
        <div style={{ width: "20%" }}>
          <span
            onClick={() => callback(page >= 2 ? page - 1 : 1)}
            className="mx-2"
          >
            <FaArrowAltCircleLeft size={22} />
          </span>
          <span className="mx-2">
            <span
              style={{
                padding: "5px 10px",
                borderRadius: "15px",
                border: "1px solid #222",
                fontSize: "11px",
              }}
            >
              {page}
            </span>
          </span>
          <span className="mx-2" onClick={() => callback(Number(page) + 1)}>
            <FaArrowAltCircleRight size={22} />
          </span>
        </div>
      </div>
    </>
  );
}

export default Pagination;
